import has from 'lodash/has'
import { PERMISSION_ENTITY_INVOICE } from '@klear/constants'
import type { CanonicalOrderEventStatusView } from '@klear/order-event-lifecycle/status-view'
import { INVOICE_STATUS_LABELS } from '@klear/invoice/presentation'

export type InvoiceLifecycleState = keyof typeof INVOICE_STATUS_LABELS
export type InvoiceOrderEventStatusView = CanonicalOrderEventStatusView<
  typeof PERMISSION_ENTITY_INVOICE,
  typeof INVOICE_STATUS_LABELS
>

export function invoiceLifecycleState(status: string): InvoiceLifecycleState | null {
  return has(INVOICE_STATUS_LABELS, status) ? (status as InvoiceLifecycleState) : null
}

export function invoiceOrderEventStatusViewFromCode(status: string): InvoiceOrderEventStatusView | null {
  const lifecycleState = invoiceLifecycleState(status)
  if (lifecycleState == null) return null
  return {
    lifecycleState,
    status: lifecycleState,
    statusLabel: INVOICE_STATUS_LABELS[lifecycleState]
  } as InvoiceOrderEventStatusView
}
